import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import anime from 'animejs'

import Meta from "../components/layout/Meta";
import { Path } from "../constants/path";

import { Link, Button } from "../components/util/Clickable";


class NotFoundScreen extends Component {

  componentDidMount = () => {
  }

  render = () => {
    return (
      <div>
        <Meta />
        <div className="uk-section">
          <div className="uk-container uk-container-small">
            <h1 className="uk-text-center">
              404 NotFound
            </h1>
            <p className="uk-margin uk-text-center">
              ページが見つかりませんでした。<br/>
              アクセスしたURLを再度確認して下さい。
            </p>
            <div className="uk-margin-large uk-text-center">
              <Link className="uk-button uk-button-primary uk-width-large@s" to={Path.root.url}>
                トップページへ戻る
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
    }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NotFoundScreen))